import { combineReducers } from 'redux';
import modalReducer from './modal-reducer';
import timeReducer from './time-reducer';
import jobReducer from './job-reducer';
import dateReducer from './date-reducer';
import routeReducer from './route-reducer';
import mobileReducer from './mobile-reducer';
import myinfoReducer from './myinfo-reducer';
import workorderReducer from './wod-reducer';
import employeesReducer from './employees-reducer';
import custReducer from './cust-reducer';
import laborReducer from './labor-reducer';
import tnmReducer from './tnm-reducer';
import feedbackReducer from './feedback-reducer';
import invoiceReducer from './invoice-reducer';
import messageReducer from './message-reducer';
import socketKeyReducer from './socketKey-reducer';
import materialsReducer from './materials-reducer';
const rootReducer = combineReducers({
  socketKey: socketKeyReducer,
  materials: materialsReducer,
  labor: laborReducer,
  invoices: invoiceReducer,
  tnms: tnmReducer,
  feedback: feedbackReducer,
  messages: messageReducer,
  custinfo: custReducer,
  employees: employeesReducer,
  workorders: workorderReducer,
  myinfo: myinfoReducer,
  modal: modalReducer,
  time: timeReducer,
  jobs: jobReducer,
  dates: dateReducer,
  route: routeReducer,
  mobile: mobileReducer
});
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js